import { ThemeType } from "@epcnetwork/core-ui-kit";

export const lightTheme: ThemeType = {
  name: "Light",
  importCallback: () => require("@epcnetwork/core-ui-kit/dist/assets/styles/light-theme.css"),
  className: "lightTheme",
};
